module.exports = __webpack_public_path__ + "static/img/i37.501df98a.png";